import axios from 'axios';
import prepareQueryString from '@/utils/prepareQueryString';
import { subject as an } from '@casl/ability';
import { adminPath } from '@/api/helpers/apiPath';

export default {
  getCharges(params) {
    return axios.get(adminPath('/work_order_charges?') + prepareQueryString(params)).then((response) => {
      return {
        workOrderCharges: response.data.map((workOrderCharge) => an('WorkOrderCharge', workOrderCharge)),
        total: response.headers['x-pagination'] && JSON.parse(response.headers['x-pagination']).total,
      };
    });
  },
  getWorkOrderCharges(workOrderId, params) {
    return axios.get(adminPath(`/work_orders/${workOrderId}/charges?`) + prepareQueryString(params)).then((response) => {
      return {
        workOrderCharges: response.data.map((workOrderCharge) => an('WorkOrderCharge', workOrderCharge)),
        total: response.headers['x-pagination'] && JSON.parse(response.headers['x-pagination']).total,
      };
    });
  },
  update(id, data) {
    return axios
      .patch(adminPath(`/work_order_charges/${id}`), {
        ...data,
      })
      .then((response) => an('WorkOrderCharge', response.data));
  },
  create(workOrderId, data) {
    return axios
      .post(adminPath(`/work_orders/${workOrderId}/charges`), {
        ...data,
      })
      .then((response) => an('RecurringCharge', response.data));
  },
  destroy(id) {
    return axios.delete(adminPath(`/work_order_charges/${id}`));
  },
  getSpreadsheet(params) {
    return axios.get(adminPath('/work_order_charges.csv?') + prepareQueryString(params), { responseType: 'blob' });
  },
  getWorkOrderSpreadsheet(workOrderId, params) {
    return axios.get(adminPath(`/work_orders/${workOrderId}/charges.csv?`) + prepareQueryString(params), { responseType: 'blob' });
  },
  getCategoryOptions() {
    return axios.get(adminPath('/work_order_charges/category_options'));
  },
};
